import { ArrowLeft } from 'lucide-react'
import { useNavigate } from 'react-router-dom'
import { useLanguage } from '../contexts/LanguageContext.jsx'

function StudentBackButton() {
  const navigate = useNavigate()
  const { language } = useLanguage()

  return (
    <button
      className="secondary-button student-back-button"
      type="button"
      onClick={() => navigate('/growth')}
    >
      <ArrowLeft size={16} />
      {language === 'en' ? 'Back to Growth' : '返回我的成长'}
    </button>
  )
}

export default StudentBackButton
